<app-text [ngClass]="textClass()" class="title" [text]="text()" />
@if (subtext !== '') {
  <app-text [ngClass]="subTextClass()" class="subtitle" [text]="subtext" />
}
